const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_authenticated-user/superuser/afpant/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_authenticated-user/superuser/afpant/")({
  loader: async () => {
    const res = await routeLoaderApiClient.superuser.organisation.$get();
    if (res.ok === false) {
      throw new Error("Failed to fetch messages");
    }
    return {
      organisations: await res.json()
    };
  },
  head: () => ({
    meta: [{
      title: "Superuser AFPANT | Alice & Bob"
    }]
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});